module.exports = __webpack_public_path__ + "static/media/invite.080abbe8.svg";